var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.randomizer.getIcon(_vm.id).img,"width":"24","max-width":"24","height":"24","max-height":"24","contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }